/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const staffUploadPictureRequestSchema = z.object({
	picture: z.instanceof(File),
});
